module.exports = __webpack_public_path__ + "static/media/ww_optimum4.4eb7f80c.gif";